"use client";
import {forwardRef, TextareaHTMLAttributes} from "react";

interface Props extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  label: string;
  error?: string;
}

const FormTextArea = forwardRef<HTMLTextAreaElement, Props>(
  ({label, error, className, ...rest}, ref) => (
    <div className="flex flex-col gap-2 font-mono">
      <label
        htmlFor={rest.id}
        className="text-[10px] font-bold text-zinc-500 uppercase tracking-widest"
      >
        [{label}]
      </label>
      <textarea
        ref={ref}
        id={rest.id}
        rows={4}
        className={`
          w-full resize-none px-4 py-2.5 rounded-none border-2 bg-zinc-950 text-zinc-100
          focus:outline-none transition-none
          placeholder:text-zinc-700 text-xs
          ${error ? "border-red-500 focus:border-red-500" : "border-zinc-800 focus:border-yellow-400"}
          ${className || ""}
        `}
        {...rest}
      />
      {error && <p className="text-[10px] text-red-500 font-bold uppercase mt-0.5">&gt;&gt; ERROR: {error}</p>}
    </div>
  ),
);
FormTextArea.displayName = "FormTextArea";
export default FormTextArea;
